import { render, staticRenderFns } from "./mobile-search.vue?vue&type=template&id=84c616b4&scoped=true&"
import script from "./mobile-search.vue?vue&type=script&lang=js&"
export * from "./mobile-search.vue?vue&type=script&lang=js&"
import style0 from "./mobile-search.vue?vue&type=style&index=0&id=84c616b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c616b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c616b4')) {
      api.createRecord('84c616b4', component.options)
    } else {
      api.reload('84c616b4', component.options)
    }
    module.hot.accept("./mobile-search.vue?vue&type=template&id=84c616b4&scoped=true&", function () {
      api.rerender('84c616b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/mobile-search.vue"
export default component.exports